// Xac dinh popup
var $signlog = $('#signlogin'),
    $lostpass = $('#lostpass'),
    $qsvpopup = $('#qsvpopup');

$signlog.find('.nav-tabs a').on('shown.bs.tab', function (e) {
	var tid = $(e.target).attr('href'),
		btn = $signlog.find('.byoauth .social'),
    padtop = 0;
  if($(window).width()>768) {
    padtop = Math.round($(tid).height()/2-btn.height()/2)-10;
  }
	btn.css('padding-top',padtop+'px');
	
	var info = $signlog.find('.byoauth p');
	if(tid=='#signin') info.html('Đăng nhập bằng');
	else info.html('Đăng ký bằng');
});


function OpenLogin(){
	$signlog.modal('show');
  $lostpass.modal('hide');
  $qsvpopup.modal('hide');
	$signlog.find('.nav-tabs a[href="#signin"]').tab('show');
	return false;
}


function OpenRegister(){
	$signlog.modal('show');
  $lostpass.modal('hide');
  $qsvpopup.modal('hide');
	$signlog.find('.nav-tabs a[href="#signup"]').tab('show');
	return false;
}

function OpenLostpass(){
  $lostpass.modal('show');
	$signlog.modal('hide');
  $qsvpopup.modal('hide');
	return false;
}

function Register(){
	if($('#pName').val()==''){
		alert("Nhập thiếu Họ tên!");
		$('#pName').select();
	}
	else if(!ValidEmail($('#pEmail').val())){
		alert("Email không hợp lệ!");
		$('#pEmail').select();
	}
	else if($('#pPass').val()==''){
		alert("Nhập thiếu Mật khẩu!");
		$('#pPass').select();
	}
	else if($('#pPass').val()!=$('#pRepass').val()){
		alert("Bạn nhập lại mật khẩu không đúng!");
		$('#pPass').select();
	}
	else {
		$('#frmRegister').submit();
	}
	return false;
}

function DoLogin(){
	if($('#lEmail').val()==''||$('#lPass').val()==''){
		alert("Bạn chưa nhập Email hoặc Mật khẩu!");
		$('#lEmail').focus();
	}
	else if(!ValidEmail($('#lEmail').val())){
		alert("Bạn nhập sai email!");
		$('#lEmail').select();
	}
	else{
		$('#frmLogin').submit();
	}	
	return false;
}

function GetPass(){
	if(!ValidEmail($('#gEmail').val())){
		alert("Bạn nhập sai email!");
		$('#gEmail').select();
	}
	else{
		$('#frmPass').submit();
	}
	return false;
}


// Export object Member
window.Member = {
  Signin: OpenLogin,
  Signup: OpenRegister,
  Login: DoLogin,
  Register: Register,
  Forget: OpenLostpass,
  Confirm: GetPass
}




// WEBPACK FOOTER //
// ./src/member.js